module.exports = __webpack_public_path__ + "static/media/image1.852e5886.png";